export const legalDocumentTypes = {
  EULA: 'end-user-licence-agreement',
  PRIVACY: 'privacy-policy',
  TERMS: 'terms-of-use',
};

export const getLegalDocumentTranslationId = (legalDocumentType) => {
  if (!legalDocumentType) return '';
  if (legalDocumentType.toLowerCase() === legalDocumentTypes.TERMS) return 'termsOfUse';
  if (legalDocumentType.toLowerCase() === legalDocumentTypes.PRIVACY) return 'privacyPolicy';
  if (legalDocumentType.toLowerCase() === legalDocumentTypes.EULA) return 'endUserLicence';
  return '';
};
